<template>
  <div class="mainDiv">
    <img :src="srcUrl" alt="" class="imgMobile" />
    <div class="textMobile">{{ err }}~</div>
  </div>
</template>
<script>
import defaultUrl from "./img/empty_empty.png";
export default {
  props: {
    err: {
      type: String,
      default: "暂无数据"
    },
    srcUrl: {
      type: String,
      default: defaultUrl
    }
  },
  data() {
    return {};
  },
  methods: {},
  created() {}
};
</script>
<style lang="less" scoped>
.mainDiv {
  // height: 100%;
  // width: 100%;
  // overflow: auto;
  // background-color: #f4f5f6;
  text-align: center;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // flex-flow: column;
  & > .imgMobile {
    width: 300px;
  }
  & > .textMobile {
    color: #999;
    font-size: 17px;
  }
}
</style>
